// removed by extract-text-webpack-plugin
module.exports = {"trendItem":"antd-pro-trendItem","up":"antd-pro-up","down":"antd-pro-down","trendItemGrey":"antd-pro-trendItemGrey"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Trend/index.less
// module id = 378
// module chunks = 0 1